import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { PaymentStats } from '../../../api/superAdminPayments/paymentsService';

interface SummaryCardsProps {
  stats: PaymentStats;
}

const SummaryCards: React.FC<SummaryCardsProps> = ({ stats }) => {
  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const cards = [
    {
      title: 'Total Revenue',
      amount: stats.totalRevenue,
      color: 'primary',
      icon: 'ph-currency-dollar',
      bgColor: '#e3f2fd',
      textColor: '#1976d2'
    },
    {
      title: 'Realized Profit',
      amount: stats.realizedProfit,
      color: 'success',
      icon: 'ph-trend-up',
      bgColor: '#e8f5e8',
      textColor: '#2e7d32'
    },
    {
      title: 'Payment Dues',
      amount: stats.paymentDues,
      color: 'warning',
      icon: 'ph-clock',
      bgColor: '#fff3e0',
      textColor: '#f57c00'
    }
  ];

  return (
    <Row className="mb-4">
      {cards.map((card, index) => (
        <Col key={index} lg={4} md={6} className="mb-3">
          <Card 
            className="summary-card h-100"
            style={{
              border: 'none',
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s ease-in-out'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <Card.Body className="d-flex align-items-center p-4">
              <div 
                className="me-3 d-flex align-items-center justify-content-center"
                style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  backgroundColor: card.bgColor,
                  color: card.textColor
                }}
              >
                <i className={`${card.icon}`} style={{ fontSize: '24px' }}></i>
              </div>
              <div className="flex-grow-1">
                <div 
                  className="fw-bold mb-1"
                  style={{ 
                    fontSize: '24px',
                    color: card.textColor,
                    lineHeight: '1.2'
                  }}
                >
                  {formatCurrency(card.amount)}
                </div>
                <div 
                  className="text-muted"
                  style={{ 
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  {card.title}
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default SummaryCards; 